import * as React from "react";
import type { SVGProps } from "react";
const SvgHamburger = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.072 6h16v2h-16zm0 5h16v2h-16zm0 5h16v2h-16z"
    />
  </svg>
);
export default SvgHamburger;
